import { addDefaultProps, addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import cx from 'classnames'
import { createUseStyles } from 'react-jss'

import { addFormContext } from './formContext'
import { Suggestion } from './Suggestion'
import { LABELS_STYLE } from './styles'

const styles = {
  container: 'relative',
  containerMargin: 'my-6',
  label: cx('text-sm', 'leading-7', 'font-medium', 'text-rodeo-grey/96'),
  labelError: 'text-rodeo-errors/89',
  errorMessage: cx(
    'text-rodeo-errors/96',
    'text-right',
    'text-sm',
    'text-sans',
    'font-medium',
    'mt-0.5'
  ),
}

interface Props {
  id?: string
  label?: string
  error?: string
  showErrorMessage?: boolean
  ignoreDisabled?: boolean
  focusOnMount?: boolean
  suggestion?: string | number | null
  placeholder?: string
  disabled?: boolean
  noMargin?: boolean
  className?: string
}

export const Field: FC<Props> = flowMax(
  addDisplayName('Field'),
  addDefaultProps({
    showErrorMessage: true,
  }),
  addFormContext,
  ({
    id,
    label,
    error,
    // formDisabled,
    // disabled,
    // ignoreDisabled,
    children,
    suggestion,
    noMargin,
    className,
  }) => (
    <>
      {suggestion && <Suggestion suggestion={suggestion} />}
      <div
        className={cx(
          styles.container,
          !noMargin && styles.containerMargin,
          className
        )}
      >
        {!!label && (
          <label
            htmlFor={id}
            className={cx(styles.label, error && styles.labelError)}
          >
            {label}
          </label>
        )}

        {children}

        {error && <p className={styles.errorMessage}>{error}</p>}
      </div>
    </>
  )
)

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  containerMargin: {
    marginBottom: 12,
  },
  errorMessage: {
    alignSelf: 'flex-end',
    ...LABELS_STYLE,
    marginTop: 4,
    paddingRight: 1,
    color: '#F57561',
    opacity: 0.8,
  },
})

export const FieldNew: FC<Props> = flowMax(
  addDisplayName('FieldNew'),
  addFormContext,
  addProps(() => ({
    classes: useStyles(),
  })),
  ({
    id,
    label,
    error,
    showErrorMessage,
    // formDisabled,
    // disabled,
    // ignoreDisabled,
    children,
    suggestion,
    noMargin,
    className,
    classes,
  }) => (
    <>
      {suggestion && <Suggestion suggestion={suggestion} />}
      <div
        className={cx(
          classes.container,
          !noMargin && classes.containerMargin,
          className
        )}
      >
        {!!label && (
          <label
            htmlFor={id}
            className={cx(styles.label, error && styles.labelError)}
          >
            {label}
          </label>
        )}

        {children}

        {showErrorMessage && error && (
          <p className={classes.errorMessage}>{error}</p>
        )}
      </div>
    </>
  )
)
